import Vue from 'vue'

Vue.filter('price', function (value) {
    if (!value) return ''
    return ( value / 100 ) + ' ₽'
})